import { DownloadBlob } from '@browser/Browser';
import { isNullOrWhitespace, roundDecimal, strCompareLowerCase } from '@common/Common';
import PortfolioOrDecisionNavigation from "@common/Components/PortfolioOrDecisionNavigation.vue";
import ConsistencyAnalysisCircles from '@Evaluation/Common/Components/ConsistencyAnalysisCircles.vue';
import { IEvaluationCommand } from '@Evaluation/cqrs';
import { CriteriaPanelistsManagerViewModel } from '@Evaluation/CriteriaSurveys/Components/CriteriaPanelistsManager';
import CriteriaPanelistsManager from '@Evaluation/CriteriaSurveys/Components/CriteriaPanelistsManager.vue';
import { CriteriaSurveyAccessLinksViewModel } from '@Evaluation/CriteriaSurveys/Components/CriteriaSurveyAccessLinks';
import CriteriaSurveyAccessLinks from '@Evaluation/CriteriaSurveys/Components/CriteriaSurveyAccessLinks.vue';
import { CriteriaSurveyEmailSenderViewModel } from '@Evaluation/CriteriaSurveys/Components/CriteriaSurveyEmailSender';
import CriteriaSurveyEmailSender from '@Evaluation/CriteriaSurveys/Components/CriteriaSurveyEmailSender.vue';
import PanelistConsistencyAnalysisDialog from '@Evaluation/CriteriaSurveys/Components/PanelistConsistencyAnalysisDialog.vue';
import { ChangeCriteriaPanelistVoteStrengthCommandV1, ExcludeCriteriaPanelistCommandV1, IncludeCriteriaPanelistCommandV1, SendEmailCommandV1 } from '@Evaluation/CriteriaSurveys/Domain/commands-core';
import CriteriaSurveyCommands from '@Evaluation/CriteriaSurveys/Domain/commands-vue-component';
import CriteriaSurveysQueries from '@Evaluation/CriteriaSurveys/Domain/queries-vue-component';
import { CriteriaDownloadAccessLinksReadModel, CriteriaPanelistReadModel, CriteriaPanelistsManagerReadModel, CriteriaPanelistsPageReadModel, CriteriaSurveyPanelistsReadModel, PanelistConsistencyAnalysisReadModel } from '@Evaluation/CriteriaSurveys/Domain/readmodels';
import { Component, mixins } from 'vue-facing-decorator';
import { dynamicUiRoutes } from '@common/dynamicUiRoutes';

@Component({
    components: { PortfolioOrDecisionNavigation, ConsistencyAnalysisCircles, PanelistConsistencyAnalysisDialog, CriteriaPanelistsManager, CriteriaSurveyAccessLinks, CriteriaSurveyEmailSender }
})
export default class CriteriaPanelistsPage extends mixins(CriteriaSurveysQueries, CriteriaSurveyCommands) {

    get workspaceId(): number { return Number(this.$route?.params?.workspaceId ?? 0); }
    get projectId(): number { return Number(this.$route?.params?.projectId ?? 0); }
    get evalModelId(): number { return Number(this.$route?.params?.evalModelId ?? 0); }
    get surveyId(): number { return Number(this.$route?.params?.surveyId ?? 0); }

    get url_Criteria_WeightsPage() { return dynamicUiRoutes.Criteria_WeightsPage(this.$route, this.workspaceId, this.projectId, this.evalModelId); }


    Initialized: boolean = false;
    tags: string[] = null;

    tagFilter: string = null;
    progressFilter: string = null;

    SurveyName: string;
    SearchPhrase: string = null;
    Panelists: CriteriaPanelistReadModel[] = null;

    panelistConsistencyAnalysis: PanelistConsistencyAnalysisReadModel = null;
    panelistConsistencyAnalysisOpened: boolean = false;

    criteriaPanelistsManager: CriteriaPanelistsManagerViewModel | null = null; 
    criteriaSurveyAccessLinks: CriteriaSurveyAccessLinksViewModel = new CriteriaSurveyAccessLinksViewModel();
    criteriaSurveyEmailSender: CriteriaSurveyEmailSenderViewModel = new CriteriaSurveyEmailSenderViewModel();

    get Progress(): number | null
    {
        if (this.Panelists.length > 0)
        {
            const sum = this.Panelists.map(a => a.Progress).reduce((questionsCount, curr) => questionsCount + curr, 0);
            return roundDecimal(sum / this.Panelists.length, 0);
        }

        return null;
    }

    get PanelistsView(): CriteriaPanelistReadModel[]
    {
        let view = new Array(...this.Panelists);

        if (!isNullOrWhitespace(this.SearchPhrase))
        {
            const phrase = this.SearchPhrase.toLowerCase();
            view = view.filter(a => a.Name.toLowerCase().indexOf(phrase) >= 0);
        }

        if (this.progressFilter)
        {
            if (this.progressFilter === 'Not started')
            {
                view = view.filter(a => a.Progress === 0);
            }
            else if (this.progressFilter === 'In progress')
            {
                view = view.filter(a => a.Progress > 0 && a.Progress < 100);
            }
            else if (this.progressFilter === 'Completed')
            {
                view = view.filter(a => a.Progress === 100);
            }
        }

        if (this.tagFilter)
        {
            view = view.filter(a => a.Tags.indexOf(this.tagFilter) > -1);
        }

        view = view.sort((a, b) => strCompareLowerCase(a.Name, b.Name));

        return view;
    }

    get NonePanelistsSelected(): boolean { return this.Panelists.some(a => a.IsSelected) === false; }
    get AnyPanelistsSelected(): boolean { return this.Panelists.some(a => a.IsSelected); }
    get AllPanelistsSelected(): boolean { return this.Panelists.length > 0 && this.Panelists.some(a => a.IsSelected === false) === false; }
    get SelectedPanelistsCount(): number { return this.Panelists.filter(a => a.IsSelected === true).length; }

    get FilterLabel(): string 
    {
        if (this.tagFilter)
        {
            return this.tagFilter;
        }

        if (this.progressFilter)
        {
            return this.progressFilter;
        }

        return "All panelists";
    }


    filterByProgress(filter: string)
    {
        this.tagFilter = null;
        this.progressFilter = filter;
    }

    filterByTag(t: string)
    {
        this.progressFilter = null;
        this.tagFilter = t;
    }

    resetFilters()
    {
        this.progressFilter = null;
        this.tagFilter = null;
    }


    AddPanelistsCommand()
    {
        this.runCriteriaPanelistsManagerQueryV1(this.workspaceId, this.surveyId);
        this.criteriaPanelistsManager.show();
    }

    EmailManyCommand()
    {
        const panelistIds = this.Panelists.filter(a => a.IsSelected === true && a.HasEmail).map(a => a.ProjectUserId);
        this.criteriaSurveyEmailSender.show(this.surveyId, panelistIds);
    }

    showCriteriaSurveyEmailSender(surveyId: number, ids: number[])
    {
        this.criteriaSurveyEmailSender.show(this.surveyId, ids);
    }

    EmailOneCommand(p: CriteriaPanelistReadModel)
    {
        if (p.HasEmail)
        {
            this.criteriaSurveyEmailSender.show(this.surveyId, [p.ProjectUserId]);
        }
        else
        {
            alert("Email not provided");
        }
    }



    DownloadLinksCommand()
    {
        this.runCriteriaAccessLinksBySurveyIdQueryV1(this.workspaceId, this.surveyId);
        this.criteriaSurveyAccessLinks.show(this.surveyId);
    }


    SelectAllCommand()
    {
        this.PanelistsView.forEach(a => a.IsSelected = true);
    }

    UnselectAllCommand()
    {
        this.PanelistsView.forEach(a => a.IsSelected = false);
    }

    InverseSelectionCommand()
    {
        this.PanelistsView.forEach(a => a.IsSelected = !a.IsSelected);
    }

    showConsistencyAnalysis(projectUserId: number)
    {
        this.panelistConsistencyAnalysis = null;
        this.panelistConsistencyAnalysisOpened = true;
        this.runPanelistConsistencyAnalysisQueryV1(this.workspaceId, this.projectId, this.evalModelId, this.surveyId, projectUserId);
    }



    handleDownloadAccessLinks(surveyId: number)
    {
        this.runExportAccessLinksBySurveyIdQueryV1(this.workspaceId, surveyId);
    }

    handleExcludePanelistsCommand(p: CriteriaPanelistReadModel)
    {
        this.invokeExcludeCriteriaPanelistCommandV1(this.workspaceId, this.surveyId, p.ProjectUserId);
    }

    handleChangeCriteriaPanelistVoteStrengthCommand(p: CriteriaPanelistReadModel, vs: number)
    {
        this.invokeChangeCriteriaPanelistVoteStrengthCommandV1(this.workspaceId, this.surveyId, p.ProjectUserId, p.VoteStrength, vs);
    }

    handleIncludeCriteriaPanelistCommand(puId: number)
    {
        this.invokeIncludeCriteriaPanelistCommandV1(this.workspaceId, this.surveyId, puId);
    }

    handleSendEmailCommand(emailSubject: string, emailBody: string)
    {
        const sender = this.criteriaSurveyEmailSender;
        this.invokeSendEmailCommandV1(this.workspaceId, sender.surveyId, sender.projectUserIds, emailSubject, emailBody);
    }


    mounted()
    {
        document.title = "Panelists | TransparentChoice";

        this.criteriaPanelistsManager = new CriteriaPanelistsManagerViewModel(this.workspaceId, this.projectId);
        this.runCriteriaPanelistsPageQueryV1(this.workspaceId, this.projectId, this.evalModelId, this.surveyId);
    }

    onSetModel(model: any, modelName: string) 
    {
        if (modelName == "CriteriaPanelistsPageReadModel")
        {
            const rm = model as CriteriaPanelistsPageReadModel;

            this.tags = rm.ProjectUsersTags;
            this.SurveyName = rm.Survey.SurveyName;
            this.Panelists = rm.Survey.Panelists;

            this.Initialized = true;
        }
        else if (modelName == "CriteriaPanelistReadModel")
        {
            const rm = model as CriteriaPanelistReadModel;
            this.Panelists = this.Panelists.filter(p => p.ProjectUserId !== rm.ProjectUserId);
            this.Panelists.push(rm);
        }
        else if (modelName == "PanelistConsistencyAnalysisReadModel")
        {
            this.panelistConsistencyAnalysis = model as PanelistConsistencyAnalysisReadModel;
        }
        else if (modelName == "CriteriaPanelistsManagerReadModel")
        {
            const rm = model as CriteriaPanelistsManagerReadModel;
            this.criteriaPanelistsManager.setData(rm);
        }
        else if (modelName == "CriteriaSurveyPanelistsReadModel")
        {
            const rm = model as CriteriaSurveyPanelistsReadModel;
            this.criteriaSurveyAccessLinks.setData(rm);
        }
        else if (modelName === "CriteriaDownloadAccessLinksReadModel")
        {
            const rm = model as CriteriaDownloadAccessLinksReadModel;
            DownloadBlob(rm.Url);
        }
    }

    onCommandSucceed(cmd: IEvaluationCommand, correlationId: string)
    {
        if (IncludeCriteriaPanelistCommandV1.matchType(cmd))
        {
            const projectUserId = Number.parseInt(correlationId);
            this.runCriteriaPanelistQueryV1(this.workspaceId, this.surveyId, projectUserId);

            const x = this.criteriaPanelistsManager.data?.ProjectUsers.find(a => a.ProjectUserId === projectUserId);

            if (x)
            {
                x.Included = true;
            }
        }
        else if (ExcludeCriteriaPanelistCommandV1.matchType(cmd))
        {
            const projectUserId = Number.parseInt(correlationId);
            this.Panelists = this.Panelists.filter(a => a.ProjectUserId !== projectUserId);
        }
        else if (ChangeCriteriaPanelistVoteStrengthCommandV1.matchType(cmd))
        {
            const projectUserId = Number.parseInt(correlationId);
            this.runCriteriaPanelistQueryV1(this.workspaceId, this.surveyId, projectUserId);
        }
        else if (SendEmailCommandV1.matchType(cmd))
        {
            alert("Sent");
            this.criteriaSurveyEmailSender.close();
        }

    }
}